interface LogoProps {
  className?: string;
}

export function BalancedLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M46.5,28.7l-5.1-13.2c1.2-.2,2.3-.6,3.3-1.2l-.9-1.5c-1.9,1.1-4.2,1.4-6.3.8l-1-.4c-2.7-1.1-5.5-1.9-8.4-2.2,1.1-1.7.7-4-1-5.1-1.7-1.1-4-.7-5.1,1-.8,1.3-.8,2.9,0,4.1-2.8.3-5.5,1.1-8,2.1l-1.1.4c-2.1.6-4.4.4-6.3-.8l-.9,1.5c1,.6,2.1,1,3.3,1.2l-5.2,13.2c-.5,0-.8.4-.8.9,0,3.9,3.2,7.1,7.2,7,3.9,0,7-3.2,7-7,0-.5-.3-.8-.8-.9l-5.1-13.1c.7,0,1.5-.2,2.2-.4,0,0,0,0,0,0l1.1-.4c2.6-1.1,5.3-1.8,8-2.1v27.5h-5.8c-.5,0-.9.4-.9.9v2.8c0,.5.4.9.9.9h16.5c.5,0,.9-.4.9-.9v-2.8c0-.5-.4-.9-.9-.9h-5.9V12.6c2.9.3,5.8,1,8.4,2.1l1.1.4s0,0,0,0c.7.2,1.4.3,2.2.4l-5.1,13.1c-.5,0-.8.4-.8.9,0,3.9,3.2,7.1,7.1,7.1s7.1-3.2,7.1-7.1-.3-.8-.8-.9M9.8,34.9c-2.6,0-4.8-1.9-5.3-4.5h10.5c-.4,2.6-2.7,4.5-5.3,4.5M14.2,28.7H5.4l4.4-11.3,4.4,11.3ZM24.8,7c1.1,0,1.9.9,1.9,2,0,1-.8,1.8-1.8,1.9h-.3c-1.1-.1-1.8-1.1-1.7-2.1.1-1,.9-1.7,1.9-1.7M25.5,12.6v27.6h-1.3V12.6h.4c0,0,.2,0,.3,0h.4c0,0,.2,0,.3,0M32.2,43h-14.7v-1.1h14.7v1.1ZM40.2,17.3l4.4,11.3h-8.8l4.4-11.3h0ZM40.2,34.9c-2.6,0-4.8-1.9-5.3-4.5h10.5c-.4,2.6-2.7,4.5-5.3,4.5" 
      />
    </svg>
  );
}